module.exports = __webpack_public_path__ + "static/media/map_pin_int_near_shared.7f2f9cb2.svg";